function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#191617;}.cls-2{fill:#fff;}.cls-3{fill:#000100;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 49.35,
  y: 18.8,
  width: 180.65,
  height: 9.44
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M54.26,26.14a2.63,2.63,0,0,1-1-.2,2.36,2.36,0,0,1-.8-.54,2.5,2.5,0,0,1-.71-1.76v0a2.47,2.47,0,0,1,.19-1,2.38,2.38,0,0,1,.53-.8,2.36,2.36,0,0,1,.8-.54,2.5,2.5,0,0,1,1-.21,2.63,2.63,0,0,1,1,.2,2.36,2.36,0,0,1,.8.54,2.55,2.55,0,0,1,.71,1.77h0a2.43,2.43,0,0,1-.19,1,2.28,2.28,0,0,1-.53.8,2.53,2.53,0,0,1-.8.55A2.66,2.66,0,0,1,54.26,26.14Zm0-.79a1.59,1.59,0,0,0,.66-.13,1.64,1.64,0,0,0,.52-.37,1.79,1.79,0,0,0,.33-.55,1.65,1.65,0,0,0,.13-.66v0a1.7,1.7,0,0,0-.13-.67,1.64,1.64,0,0,0-.34-.55,1.53,1.53,0,0,0-.52-.37,1.63,1.63,0,0,0-1.32,0,1.61,1.61,0,0,0-.52.36,2,2,0,0,0-.34.55,1.85,1.85,0,0,0-.12.67h0a1.85,1.85,0,0,0,.12.67,1.89,1.89,0,0,0,.34.55,1.54,1.54,0,0,0,.53.37A1.45,1.45,0,0,0,54.27,25.35Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M57.85,21.27H60a1.77,1.77,0,0,1,1.27.43,1.13,1.13,0,0,1,.32.81h0a1.25,1.25,0,0,1-.06.4,1.4,1.4,0,0,1-.15.3.92.92,0,0,1-.22.22,1.45,1.45,0,0,1-.26.17,2.32,2.32,0,0,1,.39.18,1.19,1.19,0,0,1,.31.23,1.09,1.09,0,0,1,.19.33,1.2,1.2,0,0,1,.07.44h0a1.21,1.21,0,0,1-.13.58,1,1,0,0,1-.36.42,1.86,1.86,0,0,1-.57.25,2.83,2.83,0,0,1-.74.09H57.85Zm2,2.05a1.15,1.15,0,0,0,.66-.16.55.55,0,0,0,.25-.5h0a.53.53,0,0,0-.22-.46,1,1,0,0,0-.63-.16H58.69v1.29Zm.25,2.06a1.12,1.12,0,0,0,.68-.17.54.54,0,0,0,.25-.5h0a.55.55,0,0,0-.24-.48,1.3,1.3,0,0,0-.75-.17H58.69v1.33Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M64.58,26.14A3,3,0,0,1,63.5,26a3.07,3.07,0,0,1-1-.59l.51-.61a3.28,3.28,0,0,0,.72.47,1.94,1.94,0,0,0,.82.16,1,1,0,0,0,.63-.17.53.53,0,0,0,.23-.44h0a.6.6,0,0,0,0-.24.54.54,0,0,0-.16-.19,1.78,1.78,0,0,0-.34-.17,4.52,4.52,0,0,0-.55-.15c-.26-.06-.49-.13-.7-.2a1.82,1.82,0,0,1-.5-.28,1,1,0,0,1-.32-.4,1.41,1.41,0,0,1-.11-.57v0a1.36,1.36,0,0,1,.13-.57,1.22,1.22,0,0,1,.34-.44,1.46,1.46,0,0,1,.52-.29,2.09,2.09,0,0,1,.67-.11,2.61,2.61,0,0,1,1,.16,2.82,2.82,0,0,1,.81.45l-.46.65A3.18,3.18,0,0,0,65,22a1.72,1.72,0,0,0-.66-.13.92.92,0,0,0-.59.17.51.51,0,0,0-.21.41h0a.66.66,0,0,0,.05.25.41.41,0,0,0,.18.19,1.27,1.27,0,0,0,.35.17l.58.16a4.58,4.58,0,0,1,.68.21,1.76,1.76,0,0,1,.49.29,1.17,1.17,0,0,1,.3.4,1.38,1.38,0,0,1,.1.52v0a1.36,1.36,0,0,1-.13.61,1.31,1.31,0,0,1-.35.46,1.68,1.68,0,0,1-.55.28A2.24,2.24,0,0,1,64.58,26.14Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M67.32,21.27h3.6V22H68.16v1.25h2.45v.78H68.16v1.3H71v.77H67.32Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M72,21.27h2.17a2.3,2.3,0,0,1,.81.13,1.73,1.73,0,0,1,.59.36,1.41,1.41,0,0,1,.3.46,1.59,1.59,0,0,1,.1.59h0a1.8,1.8,0,0,1-.08.54,1.64,1.64,0,0,1-.24.43,1.85,1.85,0,0,1-.37.31,2.22,2.22,0,0,1-.47.2l1.32,1.84h-1l-1.2-1.7H72.82v1.7H72Zm2.1,2.41a1.1,1.1,0,0,0,.73-.22.71.71,0,0,0,.27-.59v0a.71.71,0,0,0-.26-.6,1.19,1.19,0,0,0-.75-.21H72.82v1.64Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M76.59,21.24h.94L79,25l1.46-3.74h.92l-2,4.9h-.75Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M83.94,21.24h.8l2.14,4.9H86L85.48,25h-2.3l-.5,1.18H81.8Zm1.23,3-.84-1.95-.84,1.95Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M88.91,22.06H87.36v-.79h4v.79H89.77v4.08h-.86Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M94.54,26.14a2.66,2.66,0,0,1-1-.2,2.36,2.36,0,0,1-.8-.54A2.5,2.5,0,0,1,92,23.64v0a2.66,2.66,0,0,1,.19-1,2.54,2.54,0,0,1,.53-.8,2.4,2.4,0,0,1,.81-.54,2.45,2.45,0,0,1,1-.21,2.63,2.63,0,0,1,1,.2,2.36,2.36,0,0,1,.8.54,2.43,2.43,0,0,1,.53.8,2.58,2.58,0,0,1,.18,1h0a2.44,2.44,0,0,1-.71,1.77,2.7,2.7,0,0,1-.81.55A2.63,2.63,0,0,1,94.54,26.14Zm0-.79a1.63,1.63,0,0,0,.67-.13,1.59,1.59,0,0,0,.51-.37,1.82,1.82,0,0,0,.34-.55,1.84,1.84,0,0,0,.12-.66v0a1.89,1.89,0,0,0-.12-.67,1.82,1.82,0,0,0-.34-.55,1.76,1.76,0,0,0-.52-.37,1.67,1.67,0,0,0-.67-.14,1.59,1.59,0,0,0-.66.14,1.73,1.73,0,0,0-.52.36,1.79,1.79,0,0,0-.33.55,1.85,1.85,0,0,0-.12.67h0a1.85,1.85,0,0,0,.12.67,1.55,1.55,0,0,0,.34.55,1.5,1.5,0,0,0,.52.37A1.45,1.45,0,0,0,94.55,25.35Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M98.13,21.27h2.17a2.26,2.26,0,0,1,.81.13,1.64,1.64,0,0,1,.59.36,1.41,1.41,0,0,1,.3.46,1.59,1.59,0,0,1,.11.59h0a1.53,1.53,0,0,1-.09.54,1.64,1.64,0,0,1-.24.43,1.42,1.42,0,0,1-.37.31,2.13,2.13,0,0,1-.46.2l1.31,1.84h-1l-1.2-1.7H99v1.7h-.85Zm2.1,2.41a1.1,1.1,0,0,0,.73-.22.69.69,0,0,0,.28-.59v0a.72.72,0,0,0-.27-.6,1.14,1.14,0,0,0-.74-.21H99v1.64Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M103.21,21.27h.84v4.87h-.84Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M107.68,26.14a2.66,2.66,0,0,1-1-.2,2.46,2.46,0,0,1-.8-.54,2.5,2.5,0,0,1-.71-1.76v0a2.66,2.66,0,0,1,.19-1,2.54,2.54,0,0,1,.53-.8,2.5,2.5,0,0,1,.81-.54,2.46,2.46,0,0,1,1-.21,2.66,2.66,0,0,1,1,.2,2.46,2.46,0,0,1,.8.54,2.55,2.55,0,0,1,.71,1.77h0a2.62,2.62,0,0,1-.19,1,2.43,2.43,0,0,1-.53.8,2.7,2.7,0,0,1-.81.55A2.63,2.63,0,0,1,107.68,26.14Zm0-.79a1.52,1.52,0,0,0,1.17-.5,1.64,1.64,0,0,0,.34-.55,1.84,1.84,0,0,0,.12-.66v0a1.89,1.89,0,0,0-.12-.67,1.62,1.62,0,0,0-.86-.92,1.67,1.67,0,0,0-.67-.14A1.59,1.59,0,0,0,107,22a1.57,1.57,0,0,0-.51.36,1.64,1.64,0,0,0-.34.55,1.85,1.85,0,0,0-.12.67h0a1.85,1.85,0,0,0,.12.67,1.55,1.55,0,0,0,.34.55,1.5,1.5,0,0,0,.52.37A1.52,1.52,0,0,0,107.7,25.35Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M113.93,21.27h1.82a2.76,2.76,0,0,1,1,.19,2.47,2.47,0,0,1,.82.51,2.21,2.21,0,0,1,.53.77,2.48,2.48,0,0,1,.19,1v0a2.48,2.48,0,0,1-.19.95,2.35,2.35,0,0,1-.53.78,2.64,2.64,0,0,1-.82.51,2.76,2.76,0,0,1-1,.19h-1.82Zm1.81,4.1a1.75,1.75,0,0,0,.7-.13,1.46,1.46,0,0,0,.53-.34,1.42,1.42,0,0,0,.34-.52,1.76,1.76,0,0,0,.12-.66h0a1.85,1.85,0,0,0-.12-.67,1.55,1.55,0,0,0-.34-.53,1.61,1.61,0,0,0-.53-.34,1.94,1.94,0,0,0-.7-.13h-1v3.33Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M119.37,21.27H123V22h-2.75v1.25h2.44v.78h-2.44v1.3H123v.77h-3.64Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M126.17,21.27H127v4.87h-.85Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M128.32,21.27h.79l2.61,3.37V21.27h.84v4.87h-.71l-2.68-3.46v3.46h-.85Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M135,22.06h-1.54v-.79h3.95v.79h-1.55v4.08H135Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M138.32,21.27h3.6V22h-2.75v1.25h2.44v.78h-2.44v1.3H142v.77h-3.64Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M143,21.27h2.17a2.22,2.22,0,0,1,.81.13,1.64,1.64,0,0,1,.59.36,1.41,1.41,0,0,1,.3.46,1.59,1.59,0,0,1,.11.59h0a1.53,1.53,0,0,1-.09.54,1.64,1.64,0,0,1-.24.43,1.55,1.55,0,0,1-.36.31,2.46,2.46,0,0,1-.47.2l1.31,1.84h-1l-1.2-1.7h-1.07v1.7H143Zm2.1,2.41a1.13,1.13,0,0,0,.74-.22.71.71,0,0,0,.27-.59v0a.72.72,0,0,0-.27-.6,1.14,1.14,0,0,0-.74-.21h-1.25v1.64Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M148,21.27h.79l2.6,3.37V21.27h.85v4.87h-.71l-2.68-3.46v3.46H148Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M153.5,21.27h3.6V22h-2.75v1.25h2.44v.78h-2.44v1.3h2.79v.77H153.5Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M159.36,22.06h-1.55v-.79h3.95v.79h-1.54v4.08h-.86Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M165.93,21.19h3.61V22h-2.76v1.25h2.44V24h-2.44v1.3h2.79v.78h-3.64Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M170.59,21.19h.79L174,24.55V21.19h.85v4.87h-.72l-2.68-3.47v3.47h-.85Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M179.9,21.15h.79l2.14,4.91h-.9l-.5-1.18h-2.3l-.5,1.18h-.87Zm1.22,3-.84-1.94-.83,1.94Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M183.67,21.19h2.17a2.3,2.3,0,0,1,.81.13,1.57,1.57,0,0,1,.59.35,1.45,1.45,0,0,1,.3.47,1.57,1.57,0,0,1,.1.58v0a1.53,1.53,0,0,1-.08.54,1.44,1.44,0,0,1-.24.42A1.39,1.39,0,0,1,187,24a1.52,1.52,0,0,1-.47.2l1.32,1.85h-1l-1.2-1.7h-1.07v1.7h-.85Zm2.1,2.41a1.1,1.1,0,0,0,.73-.22.74.74,0,0,0,.28-.6h0a.69.69,0,0,0-.27-.6,1.19,1.19,0,0,0-.75-.21h-1.24V23.6Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M191,26.14a2.63,2.63,0,0,1-1-.19,2.48,2.48,0,0,1-.8-.53,2.44,2.44,0,0,1-.51-.79,2.72,2.72,0,0,1-.18-1v0a2.56,2.56,0,0,1,.18-1,2.47,2.47,0,0,1,.53-.81,2.41,2.41,0,0,1,.79-.54,2.45,2.45,0,0,1,1-.21,3.48,3.48,0,0,1,.58,0,2.42,2.42,0,0,1,.48.13,2,2,0,0,1,.42.2,3.27,3.27,0,0,1,.39.29l-.55.64a2.48,2.48,0,0,0-.59-.38,1.61,1.61,0,0,0-.35-.1,1.87,1.87,0,0,0-.42,0,1.44,1.44,0,0,0-.62.14,1.67,1.67,0,0,0-.5.37,2,2,0,0,0-.34.55,1.84,1.84,0,0,0-.12.66v0a1.92,1.92,0,0,0,.12.69,1.46,1.46,0,0,0,.34.55,1.5,1.5,0,0,0,.52.37,1.78,1.78,0,0,0,.67.13,2.27,2.27,0,0,0,.65-.1,2,2,0,0,0,.53-.27v-.92H191v-.74H193v2a3.17,3.17,0,0,1-.4.29,2.34,2.34,0,0,1-.47.25,3.21,3.21,0,0,1-1.16.22Z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M194.15,21.19h3.6V22H195v1.25h2.45V24H195v1.3h2.79v.78h-3.63Z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M198.81,21.19h.79l2.6,3.36V21.19h.85v4.87h-.72l-2.68-3.47v3.47h-.84Z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M205.49,22H204v-.79h4V22h-1.54v4.08h-.87Z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M208.85,21.19h.85v4.87h-.85Z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M211,21.19h.79l2.6,3.36V21.19h.85v4.87h-.71l-2.68-3.47v3.47H211Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M218.23,21.15H219l2.14,4.91h-.9l-.5-1.18h-2.3l-.5,1.18h-.87Zm1.22,3-.84-1.94-.83,1.94Z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M20.59,19.89a5,5,0,0,0-1.63-1,5.92,5.92,0,0,0-4.12,0,5.38,5.38,0,0,0-1.66,1,4.94,4.94,0,0,0-1.1,1.53,4.49,4.49,0,0,0-.39,1.86v0a4.35,4.35,0,0,0,.4,1.86,4.64,4.64,0,0,0,1.08,1.51,5.17,5.17,0,0,0,1.64,1,5.92,5.92,0,0,0,4.12,0,5.33,5.33,0,0,0,1.65-1,4.74,4.74,0,0,0,1.1-1.53,4.54,4.54,0,0,0,.4-1.86v0a4.46,4.46,0,0,0-.4-1.85A4.57,4.57,0,0,0,20.59,19.89Zm-1.53,3.39v0a2.13,2.13,0,0,1-.16.84,2.08,2.08,0,0,1-.44.69,2,2,0,0,1-.68.46,2.11,2.11,0,0,1-.89.17,2.28,2.28,0,0,1-.89-.17,2.14,2.14,0,0,1-.69-.48,2.22,2.22,0,0,1-.61-1.53v0a2.31,2.31,0,0,1,.16-.83,2.23,2.23,0,0,1,.43-.69,2.25,2.25,0,0,1,1.57-.64,2.11,2.11,0,0,1,.89.18,2.18,2.18,0,0,1,.7.48,2,2,0,0,1,.45.7A2.12,2.12,0,0,1,19.06,23.28Z"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-3",
  x: 22.76,
  y: 18.68,
  width: 2.97,
  height: 9.21
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M33.05,18.61H30.32L26.2,27.88h3.13L30,26.31h3.32L34,27.88h3.19ZM32.41,24h-1.5l.75-1.8Z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M24,5.64A17.88,17.88,0,0,1,36.64,36.16,17.88,17.88,0,1,1,11.36,10.88,17.73,17.73,0,0,1,24,5.64m0-3.12a21,21,0,1,0,21,21,21,21,0,0,0-21-21Z"
});

var SvgLogoEmbed = function SvgLogoEmbed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 233 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoEmbed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_embed.23ed585c.svg";
export { ForwardRef as ReactComponent };